import styles from "./Bio.module.css";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GoogleIcon from "@mui/icons-material/Google";
import { Box } from "@mui/material";

function Bio() {
  return (
    <div className={styles.bio}>
      <p>
        An enthusiastic, advanced software engineer for digital services with a
        passion for software architecture, design, and innovative applications
        development. Also, I excel in creating reliable and user-friendly
        systems. As a dedicated PhD student and professional, I bring strong
        research and communication skills to tackle challenging projects, either
        working alone, or within a team. I love to learn more and more about the
        new technologies of this new world.
        <span className={styles.biospan}>
          In other words, I build different software, and I enjoy doing it
        </span>
      </p>
      <div className={styles.contact}>
        <div
          onClick={() => {
            window.open(
              "mailto:salmanchafik@gmail.com?subject=Internship&body=write your email here",
            );
          }}
          className={styles.element}
        >
          <MailOutlineIcon sx={{ fontSize: 35 }} />
          <h4>Email</h4>
        </div>
        <div
          onClick={() => {
            window.open(
              "https://scholar.google.com/citations?user=RUxbnKUAAAAJ&hl=fr&oi=ao",
            );
          }}
          className={styles.element}
        >
          <GoogleIcon sx={{ fontSize: 35 }} />
          <h4>Scholar</h4>
        </div>

        <div
          className={styles.element}
          onClick={() => {
            window.open(
              "https://www.linkedin.com/in/salmane-chafik-1404981b8/",
            );
          }}
        >
          <LinkedInIcon sx={{ fontSize: 35 }} />
          <h4>LinkedIn</h4>
        </div>
        <div
          onClick={() => {
            window.open("https://huggingface.co/salmane11");
          }}
          className={styles.element}
        >
          <Box
            component="img"
            src="/images/huggingface icon.webp"
            alt="huggingface icon"
            sx={{ width: 35, height: 35 }}
          />
          <h4>HuggingFace</h4>
        </div>
        <div
          onClick={() => {
            window.open("https://github.com/salmane11");
          }}
          className={styles.element}
        >
          <GitHubIcon sx={{ fontSize: 35 }} />
          <h4>GitHub</h4>
        </div>
      </div>
      <h4 className={styles.mail}>
        <span>Uni email : </span> chafik.salmane@um6p.ma
      </h4>
      <h4 className={styles.mail}>
        <span>Personal email : </span> salmanchafik@gmail.com
      </h4>
      <h4 className={styles.mail}>
        <span>phone number : </span> +212675724727
      </h4>
    </div>
  );
}
export default Bio;
